import { createSlice } from '@reduxjs/toolkit';
export const auth = createSlice({
  name: 'auth',
  initialState: {
    token: '',
    hasPass: false,
    isCompleted: false,
    isRegistered: false,
    userToken: '',
    loading: false,
    mobile: '',
    url: '/',
    message: '',
    campaignReferralCode: '',
    campaignGameCode: '',
    step: "login",
    isOpenModal: false,
    loginLoading: false,
    ResendWaitSeconds: 0,
    // determines where user is logged in specifically header 
    entry: "",
  },
  reducers: {
    AUTHENTICATION_REQUEST: (state, action) => {
      state.mobile = action.payload
      state.message = ''
      state.loading = true
    },
    AUTHENTICATION_SUCCESS: (state, action) => {
      state.token = action.payload.token
      state.message = ''
      state.loading = false
      state.ResendWaitSeconds = action.payload.ResendWaitSeconds
    },
    OTP_SUCCESS: (state, action) => {
      state.isCompleted = action.payload.data.Completed
      state.message = action.payload.data.Description
      state.hasPass = action.payload.data.HasPassword
      state.userToken = action.payload.data.JWT
      state.isRegistered = action.payload.data.Registered
    },
    REGISTER_COMPELETE: (state, action) => {
      state.isRegistered = true
    },
    LOG_OUT_ALL: (state, action) => {
      state.token = ''
      state.hasPass = false
      state.isCompleted = false
      state.isRegistered = false
      state.userToken = ''
      state.loading = false
      state.mobile = ''
      state.url = '/'
      state.message = ''
      state.step = "login"
      state.isOpenModal = false
      state.loginLoading = false
    },
    SET_REFFERAL_CODE: (state, action) => {
      state.campaignReferralCode = action.payload
    },

    OTP_TIME_LEFT: (state, action) => {
      return {
        ...state, ResendWaitSeconds: state.ResendWaitSeconds - 1
      }
    },
    setEntry: (state, action) => {
      return {
        ...state, entry: action.payload
      }
    },

    SET_GAME_CODE: (state, action) => {
      state.campaignGameCode = action.payload
    },
    SET_STEP: (state, action) => {
      state.step = action.payload
    },
    SET_LOGIN_LOADING: (state, action) => {
      state.loginLoading = action.payload
    },
    SET_LOGIN_MODAL: (state, action) => {
      state.isOpenModal = action.payload
    }
  },
});
export const { AUTHENTICATION_REQUEST,
  AUTHENTICATION_SUCCESS,
  OTP_SUCCESS,
  REGISTER_COMPELETE,
  LOG_OUT_ALL,
  SET_REFFERAL_CODE,
  SET_GAME_CODE,
  SET_STEP,
  SET_LOGIN_LOADING,
  SET_LOGIN_MODAL,
  OTP_TIME_LEFT,
  setEntry
} = auth.actions;
export default auth.reducer;
